import i18n from "@/plugins/i18n";

export function getCompletedPaperColumns(handlers) {
  return getColumns(handlers, completedPaperColumns);
}

export function getPaperStatusColumns(handlers) {
  return getColumns(handlers, paperStatusColumns);
}

export function getAdminPaperStatusColumns(handlers) {
  return getColumns(handlers, adminPaperStatusColumns);
}

function getColumns(handlers, columns) {
  return columns.map((column) => {
    if (column.type === "button") {
      column.actions.forEach((action) => {
        action.handler = getHandler(handlers, action);
      });
    }
    return column;
  });
}

function getHandler(handlers, action) {
  return handlers[action.key] || null;
}

const completedPaperColumns = [
  {
    text: i18n.t("label.status"),
    value: "status_label",
    type: "text",
    highlighted: true,
  },
  {
    text: i18n.t("label.level"),
    value: "level",
    type: "text",
  },
  {
    text: i18n.t("label.title"),
    value: "title_ko",
    type: "text",
  },
  {
    text: i18n.t("label.submission_date"),
    value: "created_at",
    type: "text",
  },
  {
    text: i18n.t("label.review_result"),
    type: "button",
    actions: [
      {
        icon: "description",
        buttonClass: "md-gray md-round",
        key: "showReview",
        handler: null,
      },
    ],
  },
  {
    text: i18n.t("label.actions"),
    type: "button",
    actions: [
      {
        icon: "search",
        buttonClass: "md-gray md-round",
        key: "showDetail",
        handler: null,
      },
    ],
  },
];

const paperStatusColumns = [
  {
    text: i18n.t("label.status"),
    value: "status_label",
    type: "text",
    highlighted: true,
  },
  {
    text: i18n.t("label.level"),
    value: "level",
    type: "text",
  },
  {
    text: i18n.t("label.journal"),
    value: "journal",
    subField: "title",
    type: "text",
  },
  {
    text: i18n.t("label.title"),
    value: "title",
    type: "text",
  },
  {
    text: i18n.t("label.created_at"),
    value: "created_at",
    type: "text",
  },
  {
    text: i18n.t("label.actions"),
    type: "button",
    actions: [
      {
        icon: "search",
        color: "black",
        key: "showDetail",
        handler: null,
      },
      {
        icon: "edit",
        color: "primary",
        key: "edit",
        handler: null,
      },
      {
        icon: "delete_forever",
        color: "red",
        key: "delete",
        handler: null,
      },
    ],
  },
];

const adminPaperStatusColumns = [
  {
    text: i18n.t("label.status"),
    value: "status_label",
    type: "text",
    highlighted: true,
  },
  {
    text: i18n.t("label.level"),
    value: "level",
    type: "text",
  },
  {
    text: i18n.t("label.journal"),
    value: "journal",
    subField: "title",
    type: "text",
  },
  {
    text: i18n.t("label.title"),
    value: "title",
    type: "text",
  },
  {
    text: i18n.t("label.submitter"),
    value: "submitter",
    subField: "name",
    type: "text",
  },
  {
    text: i18n.t("label.created_at"),
    value: "created_at",
    type: "text",
  },
  {
    text: i18n.t("label.actions"),
    type: "button",
    actions: [
      {
        icon: "search",
        color: "black",
        key: "showDetail",
        handler: null,
      },
      {
        icon: "edit",
        color: "primary",
        key: "edit",
        handler: null,
      },
    ],
  },
];

